import { apiClient } from '../../config/axios.config';
import {
  BASE_URL,
  BASE_EXPENSE_URL,
  BASE_AUTOCOMPLETE_URL,
  BASE_COMMON_URL,
  BASE_HR_EXPENSE_URL,
  BASE_HR_URL,
  CODE_LIST_URL,
} from '../apiConfig';

const fetchExpenseHistory = async payload => {
  const response = await apiClient.create(
    `${BASE_URL}${BASE_EXPENSE_URL}/get-details`,
    payload,
  );
  return response;
};

export const fetchEmployeesAutoComplete = async payload => {
  const response = await apiClient.create(
    `${BASE_URL}${BASE_AUTOCOMPLETE_URL}/get-employees`,
    payload,
  );
  return response;
};

const applyExpenseClaim = async payload => {
  const response = await apiClient.create(
    `${BASE_URL}${BASE_EXPENSE_URL}/save`,
    payload,
  );
  return response.data;
};

const fetchCodeList = async payload => {
  const response = await apiClient.create(
    `${BASE_URL}${CODE_LIST_URL}`,
    payload,
  );
  return response.result;
};

const fetchDefaultCurrency = async payload => {
  const response = await apiClient.create(
    `${BASE_URL}${BASE_EXPENSE_URL}/get-default/currency`,
    payload,
  );
  return response;
};

// Get all Country Currency
const fetchAllCountryCurrency = async payload => {
  const response = await apiClient.create(
    `${BASE_URL}${BASE_AUTOCOMPLETE_URL}/get-picklist-details`,
    payload,
  );
  return response;
};
const fetchReimburseRate = async payload => {
  const response = await apiClient.create(
    `${BASE_URL}${BASE_COMMON_URL}/reimburse`,
    payload,
  );
  return response.result;
};

// Upload expense document
const uploadAttachment = async payload => {
  const response = await apiClient.create(
    `${BASE_URL}${BASE_EXPENSE_URL}/save-attach-multi`,
    payload,
    {
      headers: {
        'Content-Type': 'multipart/form-data; charset=utf-8',
        Accept: 'application/json',
        'Accept-Charset': 'utf-8',
      },
    },
  );
  return response;
};

// save expense claim details
export const saveExpenseClaim = async payload => {
  const response = await apiClient.create(
    `${BASE_URL}${BASE_EXPENSE_URL}/save`,
    payload,
  );
  return response;
};

export const fetchExpenseClaimDetails = async payload => {
  const response = await apiClient.create(
    `${BASE_URL}${BASE_EXPENSE_URL}/details`,
    payload,
  );
  return response;
};

export const cancelExpenseClaim = async payload => {
  const response = await apiClient.create(
    `${BASE_URL}${BASE_EXPENSE_URL}/cancel`,
    payload,
  );
  return response;
};

export const fetchAttachments = async payload => {
  const response = await apiClient.create(
    `${BASE_URL}${BASE_EXPENSE_URL}/get-attach`,
    payload,
  );
  return response;
};

export const submitExpenseClaim = async payload => {
  const response = await apiClient.create(
    `${BASE_URL}${BASE_EXPENSE_URL}/submit`,
    payload,
  );
  return response;
};

export const validateExpenseClaim = async payload => {
  const response = await apiClient.create(
    `${BASE_URL}${BASE_EXPENSE_URL}/validate`,
    payload,
  );
  return response;
};

export const printExpenseClaim = async payload => {
  const response = await apiClient.create(
    `${BASE_URL}${BASE_EXPENSE_URL}/print`,
    payload,
  );
  return response;
};

export const deleteExpenseClaimAttachmentList = async payload => {
  const response = await apiClient.create(
    `${BASE_URL}${BASE_EXPENSE_URL}/delete-attach-list`,
    payload,
  );
  return response;
};

export const printExpenseClaimAttachment = async payload => {
  const response = await apiClient.create(
    `${BASE_URL}${BASE_EXPENSE_URL}/export`,
    payload,
    {
      responseType: 'blob',
    },
  );
  return response;
};

export const deleteExpenseClaimAttachment = async payload => {
  const response = await apiClient.delete(
    `${BASE_URL}${BASE_EXPENSE_URL}/del-attach`,
    { data: payload },
  );
  return response;
};

export const saveARExpenseClaim = async payload => {
  const response = await apiClient.create(
    `${BASE_URL}${BASE_EXPENSE_URL}/advance`,
    payload,
  );
  return response;
};

export const fetchExpenseClaimDetailsListWithQuery = async payload => {
  const response = await apiClient.create(
    `${BASE_URL}${BASE_EXPENSE_URL}/get-details-query`,
    payload,
  );
  return response;
};

// HR Related APIs ==========================================
export const saveProcessExpenseClaim = async payload => {
  const response = await apiClient.create(
    `${BASE_URL}${BASE_HR_EXPENSE_URL}/process-save`,
    payload,
  );
  return response;
};

// Accept Expense Claim
export const acceptProcessExpenseClaim = async payload => {
  const response = await apiClient.put(
    `${BASE_URL}${BASE_HR_EXPENSE_URL}/process-accept`,
    payload,
  );
  return response;
};

// Submit Expense Claim
export const submitProcessExpenseClaim = async payload => {
  const response = await apiClient.create(
    `${BASE_URL}${BASE_HR_EXPENSE_URL}/process-submit`,
    payload,
  );
  return response;
};

// Reject Expense Claim HR
export const rejectProcessExpenseClaim = async payload => {
  const response = await apiClient.put(
    `${BASE_URL}${BASE_HR_EXPENSE_URL}/process-reject`,
    payload,
  );
  return response;
};

const fetchHRExpenseClaimEnquiry = async payload => {
  const response = await apiClient.create(
    `${BASE_URL}${BASE_HR_URL}/expense/enquiry`,
    payload,
  );
  return response;
};

export const fetchHRProcessClaimEnquiry = async payload => {
  const response = await apiClient.create(
    `${BASE_URL}${BASE_HR_URL}/expense/process-search`,
    payload,
  );
  return response;
};

export {
  fetchExpenseHistory,
  applyExpenseClaim,
  fetchCodeList,
  fetchReimburseRate,
  fetchDefaultCurrency,
  fetchAllCountryCurrency,
  uploadAttachment,
  fetchHRExpenseClaimEnquiry,
};
